import React from "react";
import { useTheme } from "@mui/styles";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    mt: { md: "14px" },
    width: { md: "700px", lg: "900px", xl: "1198px" },
    justifyContent: { md: "space-around" },
  },
  boxContainer: {
    display: "flex",
    flexDirection: { xs: "column" },
    mt: { xs: "77.5px", md: "30px", xl: 0 },
  },
  boxContainer2: {
    display: "flex",
    flexDirection: { xs: "column" },
    mt: { xs: "55px", md: "30px", xl: 0 },
  },
  remote: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
  },
  remoteTitle: {
    fontSize: { xs: "25px", md: "24px" },
    lineHeight: { xs: "36px" },
    fontFamily: theme.typography.montserrat.bold,
    textAlign: { xs: "center", md: "start" },
    mt: { xs: "24.5px", md: 0 },
    color: theme.palette.white.main,
    maxWidth: { xs: "283px" },
    height: { xs: "36px" },
    ml: { md: "14px" },
  },
  remoteImgContainer: {
    height: { xs: "57px", md: "auto" },
    width: { xs: "57px", md: "auto" },
    backgroundColor: { xs: "rgba(126, 206, 250, 0.15)", md: "transparent" },
    borderRadius: "10px",
    display: "flex",
    justifyContent: { xs: "center" },
    alignItems: { xs: "center" },
  },

  remoteImg: {
    height: "27px",
    width: "27px",
  },
  remoteSubtitle: {
    fontSize: { xs: "24px", md: "26px", lg: "28px", xl: "30px" },
    lineHeight: { xs: "36px" },
    fontFamily: theme.typography.anaHeim.regular,
    textAlign: { xs: "center" },
    mt: { xs: "12px" },
    color: theme.palette.white.main,
    maxWidth: { xs: "243px" },
  },
  imgAndTitleContainer: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "center" },
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: { md: "baseline" },
    ml: { md: "30px", lg: "40px", xl: "54px" },
  },
});

const CodingChallengeRemote = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const { remote, exercises, free } = useTranslation(
    pathname,
    "CodingChallengeRemote"
  );

  return (
    <Box sx={classes.container}>
      <Box sx={classes.boxContainer}>
        <Box sx={classes.remote}>
          <Box sx={classes.imgAndTitleContainer}>
            <Box sx={classes.remoteImgContainer}>
              <img
                src={remote.img.src}
                alt={remote.img.alt}
                style={classes.remoteImg}
              />
            </Box>
            <Typography sx={classes.remoteTitle}>{remote.title}</Typography>
          </Box>
          <Box sx={classes.textContainer}>
            <Typography sx={classes.remoteSubtitle}>
              {remote.description[0]}
            </Typography>
            <Typography sx={classes.remoteSubtitle}>
              {remote.description[1]}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={classes.boxContainer2}>
        <Box sx={classes.remote}>
          <Box sx={classes.imgAndTitleContainer}>
            <Box sx={classes.remoteImgContainer}>
              <img
                src={exercises.img.src}
                alt={exercises.img.alt}
                style={classes.remoteImg}
              />
            </Box>
            <Typography sx={classes.remoteTitle}>{exercises.title}</Typography>
          </Box>
          <Box sx={classes.textContainer}>
            <Typography sx={classes.remoteSubtitle}>
              {exercises.description[0]}
            </Typography>
            <Typography sx={classes.remoteSubtitle}>
              {exercises.description[1]}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={classes.boxContainer2}>
        <Box sx={classes.remote}>
          <Box sx={classes.imgAndTitleContainer}>
            <Box sx={classes.remoteImgContainer}>
              <img
                src={free.img.src}
                alt={free.img.alt}
                style={classes.remoteImg}
              />
            </Box>
            <Typography sx={classes.remoteTitle}>{free.title}</Typography>
          </Box>
          <Box sx={classes.textContainer}>
            <Typography sx={classes.remoteSubtitle}>
              {free.description[0]}
            </Typography>
            <Typography sx={classes.remoteSubtitle}>
              {free.description[1]}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CodingChallengeRemote;
